import { CheckboxSelector } from '@Knowledge-OTP/znk-ui-components'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const ServicesFilter = (props) => {
  const { translate } = useTranslation()
  const { servicesFilters = [], setServicesFilters = () => {}, title = translate('filters.plans.services.title') } = props

  const services = useSelector((state) => state.user.services)
  const selectorData = useMemo(() =>
    services.slice().sort((a, b) => a.name.localeCompare(b.name)).map((item) => ({ name: item.name, id: item.id })
    ), [services]
  )
  return (
    <CheckboxSelector
      setDataFilters={setServicesFilters}
      direction='bottom'
      dataFilters={servicesFilters}
      typeFilter='services'
      data={selectorData}
      strings={{
        viewAll: translate('filters.plans.viewAll'),
        buttonCancel: translate('filters.plans.buttonCancel'),
        buttonApply: translate('filters.plans.buttonApply'),
        search: translate('filters.plans.search')
      }}
    >
      <FilterBadge
        title={title}
        options={selectorData}
        selectedIds={servicesFilters}
        onClearFilters={() => setServicesFilters([])}
      />
    </CheckboxSelector>
  )
}
export default ServicesFilter
